module.exports = __webpack_public_path__ + "img/Angiogenesis-CRC_GSE225857.5926497b.png";